import axios from 'axios'
import settings from '../settings/apis.js'
import { store } from '../store/index.js'

class UploadFilesApi {
    constructor() {
        this.Api = axios.create({
            baseURL: settings[process.env.NODE_ENV].boApiUrl,
            withCredentials: false,

            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Access-Token': store.getters['user/accessToken']
            }
        });
    }

    uploadOnjnFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.Api.post('/players/uploadOnjnFile', formData)
    }
}


export {
    UploadFilesApi
}